module.exports = __webpack_public_path__ + "img/jgzh.3ee397ea.jpg";